import { Component, inject } from '@angular/core';

import { SurveyConditionalsService } from '../../../../services/survey-conditionals.service';

@Component({
  selector: 'empathy-conditional-text-form',
  templateUrl: './conditional-text-form.component.html',
  styleUrls: ['./conditional-text-form.component.scss']
})
export class ConditionalTextFormComponent {
  surveyConditionalsService = inject(SurveyConditionalsService);

  onSelectValueToMatch(): void {
    this.surveyConditionalsService.onUpdateTextOperatorValues();
  }
}
